import { Grid, TextField, Paper, Typography, Divider } from "@mui/material";
import { ConsultationGuideData } from "../GuideDetailsDialog";

interface ObservationsSectionProps {
  formData: ConsultationGuideData;
  onFieldChange: (name: string, value: any) => void;
}

export const ObservationsSection = ({
  formData,
  onFieldChange,
}: ObservationsSectionProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Observações
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Observações / Justificativas"
            name="observacao"
            value={formData.observacao}
            onChange={handleChange}
            size="small"
            multiline
            rows={3}
            helperText="Observações ou justificativas adicionais"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
